import { m365AppDefinitionsBehaviorSubject } from '../state';
export const searchAppDefinitions = (appId) => m365AppDefinitionsBehaviorSubject.value.find((_) => _.id === appId);
//# sourceMappingURL=searchAppDefinitions.js.map